import { useMemo } from 'react'

import { AgChartOptions } from 'ag-charts-community'

import { CustomAgChart } from '@fortem-monorepo/react-ag'

import { ICReportChartPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { beta } from '@/react-query/queries/ic-report/hooks'

export interface BetaScenarioChartProps extends ICReportChartPrimitive {}

export const BetaScenarioChart: React.FC<BetaScenarioChartProps> = ({ params, options }) => {
  const query = beta.useHistoricalEventsNew(params)
  const data = query.data

  const dataFormatted = useMemo(() => {
    return (data?.data ?? []).map((data) => ({
      ...data,
      return_t: data.return_t * 100,
      return_tmo: data.return_tmo * 100,
    }))
  }, [data])

  const mergedOptions: AgChartOptions<NonNullable<typeof data>['data'][number]> = {
    data: dataFormatted,
    height: 500,
    series: [
      {
        type: 'bar',
        xKey: 'shock_name',
        yKey: 'return_tmo',
        yName: 'Return T-1',
      },
      {
        type: 'bar',
        xKey: 'shock_name',
        yKey: 'return_t',
        yName: 'Return',
      },
    ],
    axes: [
      {
        type: 'category',
        position: 'bottom',
        paddingInner: 0.5,
      },
      {
        type: 'number',
        position: 'left',
        interval: {
          minSpacing: 20,
        },
        label: {
          formatter: function (params) {
            return `${params?.value?.toFixed(2)}%`
          },
        },
      },
    ],
    ...options,
  }

  return <CustomAgChart options={mergedOptions} />
}
